import { useEffect, useState } from 'react';

export const useStateWithLocalStorage = (
    localStorageKey: string
): [string, React.Dispatch<React.SetStateAction<string>>] => {
    const [value, setValue] = useState(localStorage.getItem(localStorageKey) || '');

    useEffect(() => {
        localStorage.setItem(localStorageKey, value);
    }, [value, localStorageKey]);

    return [value, setValue];
};
